export const meta = {
  title: "Luxe Durable : Comment Voyager de Manière Responsable dans les Alpes",
  description: "Le luxe peut-il être écologique ? Découvrez comment Beatenberg Resort & Spa protège l'environnement alpin grâce à des pratiques durables.",
  date: "2024-03-22",
  image: "/images/local_attractions/beatenberg_trail.main-1000h.webp",
  author: "Équipe Verte Beatenberg",
  category: "Durabilité",
  keywords: ["hôtels durables suisse", "voyage écologique alpes", "tourisme responsable interlaken", "hôtel vert suisse"],
  faqs: [
    {
      question: "Le resort est-il certifié ?",
      answer: "Oui, nous sommes fiers détenteurs du label 'Ibex Fairstay' pour la performance de gestion durable."
    },
    {
      question: "Avez-vous des stations de recharge pour véhicules électriques ?",
      answer: "Oui, nous avons 4 stations de recharge pour véhicules électriques haute vitesse disponibles pour les invités dans notre garage de parking."
    }
  ]
}

# Luxe Durable : Comment Voyager de Manière Responsable dans les Alpes

Les Alpes suisses ne sont pas seulement un arrière-plan pour notre resort ; elles sont notre maison et notre héritage. Nous croyons que le vrai luxe réside dans la préservation de cet environnement vierge pour les générations futures.

<JournalQuote>
  "Nous n'héritons pas de la terre de nos ancêtres ; nous l'empruntons à nos enfants."
</JournalQuote>

## Nos Initiatives "Vertes"
Nous avons mis en place une stratégie de durabilité complète qui ne compromet pas le confort.

<JournalList items={[
  "Chauffage au Bois : Notre resort est connecté au réseau de chauffage aux copeaux de bois local de Beatenberg, utilisant le bois des forêts locales pour fournir une chaleur neutre en carbone.",
  "Conservation de l'Eau : Nous utilisons des robinets optimisés pour le débit qui maintiennent la pression tout en réduisant l'utilisation de l'eau de 30%.",
  "Pas de Plastiques à Usage Unique : Vous ne trouverez pas de bouteilles d'eau en plastique dans nos chambres. Nous fournissons des bouteilles en verre et de l'eau du robinet alpine pure.",
  "Approvisionnement Local : 80% de nos ingrédients alimentaires proviennent d'un rayon de 50km du resort."
]} />

<JournalImage 
  src="/images/Views/a_green_valley_with_houses_and_trees_and_mountains_43.jpg" 
  alt="Vallée alpine verte"
  caption="Préserver les vallées vertes luxuriantes de Beatenberg est notre priorité."
/>

## Comment Vous Pouvez Aider
Le voyage durable est un partenariat. Voici comment vous pouvez rendre votre séjour plus vert :

1.  **Utilisez les Transports Publics** : Profitez du laissez-passer bus gratuit de la Carte Invité.
2.  **Respectez les Sentiers** : Restez sur les sentiers de randonnée balisés pour protéger la flore alpine sensible.
3.  **Buvez l'Eau du Robinet** : L'eau du robinet suisse est de qualité eau minérale. Remplissez votre bouteille !

<JournalCallout title="La Promesse Ibex">
  Pour chaque réservation directe effectuée via notre site web, nous donnons 5 CHF au fonds local de protection de la faune, soutenant l'habitat du Bouquetin Alpin.
</JournalCallout>

<JournalAccordion items={[
  {
    question: "Le resort est-il certifié ?",
    answer: "Oui, nous sommes fiers détenteurs du label 'Ibex Fairstay' pour la performance de gestion durable."
  },
  {
    question: "Avez-vous des stations de recharge pour véhicules électriques ?",
    answer: "Oui, nous avons 4 stations de recharge pour véhicules électriques haute vitesse disponibles pour les invités dans notre garage de parking."
  }
]} />

<JournalCTA href="/fr/book">Réservez Votre Séjour Durable</JournalCTA>
